<div class="tr diff-row pending-field-row" [ngClass]="{'is-blocked': blocked}">
  <div class="td text-ellipsis">
    <span class="br-body-1 tr-label">{{ 'PLANNING_DRAFT_JOB_CHANGES_FIELDS.' + field | translate }}</span>
  </div>
  @if (field === packagesField) {
    <div class="td text-ellipsis package-field-diffs">
      @for (diff of packageFieldDiffs; track diff.label) {
        <div class="package-field-diff-line" [ngbTooltip]="(diff.label | translate) + ': ' + diff.oldValue" openDelay="300" triggers="hover">
          <span class="package-field-diff-label">{{ diff.label | translate }}:</span> {{ diff.oldValue }}
        </div>
      }
    </div>
    <div class="td text-ellipsis package-field-diffs">
      @for (diff of packageFieldDiffs; track diff.label) {
        <div class="package-field-diff-line" [ngbTooltip]="(diff.label | translate) + ': ' + diff.newValue" openDelay="300" triggers="hover">
          <span class="package-field-diff-label">{{ diff.label | translate }}:</span> {{ diff.newValue }}
        </div>
      }
    </div>
  } @else {
    <div class="td text-ellipsis" [ngbTooltip]="formatValue(initialValue)" openDelay="300" triggers="hover">
      {{ formatValue(initialValue) }}
    </div>
    <div class="td text-ellipsis" [ngbTooltip]="formatValue(pendingValue)" openDelay="300" triggers="hover">
      {{ formatValue(pendingValue) }}
    </div>
  }
  <div class="td tr-icon">
    @if (blocked) {
      <bringoz-icon iconName="info" classSize="sm" [ngbTooltip]="'PLANNING_DRAFT_JOB_CHANGES_DISABLED_TOOLTIP' | translate" openDelay="300" triggers="hover"></bringoz-icon>
    }
  </div>
</div>
